module.exports = {
    userInfo:{
        name:'Name',
        number:'Contact information',
        EMail:'E-mail',
        massage:'Message content',
        followUs:'Follow us'
    }
}